"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionPersistence = exports.SESSION_NOT_TRACKED = exports.SESSION_COOKIE_EXPIRATION_DELAY = exports.SESSION_EXPIRATION_DELAY = exports.SESSION_TIME_OUT_DELAY = void 0;
const timeUtils_1 = require("../../tools/utils/timeUtils");
exports.SESSION_TIME_OUT_DELAY = 4 * timeUtils_1.ONE_HOUR;
exports.SESSION_EXPIRATION_DELAY = 15 * timeUtils_1.ONE_MINUTE;
exports.SESSION_COOKIE_EXPIRATION_DELAY = timeUtils_1.ONE_YEAR;
exports.SESSION_NOT_TRACKED = '0';
/**
 * @internal
 */
exports.SessionPersistence = {
    COOKIE: 'cookie',
    LOCAL_STORAGE: 'local-storage',
};
//# sourceMappingURL=sessionConstants.js.map